<div class="timer">
  @for (unit of timeUnits(); track $index; let first = $first) {
  <div style="display: flex; background-color: black; place-items: center" 
            [ngStyle]="{ height: fromUserCodePages() ? '70%' : '' }"
  
  >
    <div class="time-box">
      <div class="flip-card">
        <div class="time-value">{{ unit?.value }}</div>
      </div>
    </div>
    @if (first && timeUnits().length > 1) {
    <div class="time-value colon">:</div>
    }
  </div>
  }
</div>
